// extracted by mini-css-extract-plugin
module.exports = {"AntTable":"AntTable__AntTable___iDWTp"};